export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14027.cf3ff495.jpg";